import * as React from "react";

import { MenuItem } from "./MenuItem";
import { Submenus } from "./Submenus";
import { MenuRow } from "./atoms/MenuRow";
import { IMenuItem } from "../../IMenuItem";

interface Props {
  menuItem: IMenuItem;
  level: number;
  expanded: boolean;
  shouldShow: boolean;
  expandedIndex: number[];
  toggleExpandFn: (level: number, index: number) => void;
  toggleExpand: () => void;
}

export const MenuGroup = ({
  menuItem,
  level,
  expanded,
  expandedIndex,
  toggleExpandFn,
  toggleExpand
}: Props) => (
  <MenuRow>
    <MenuItem
      key={0}
      menuItem={menuItem}
      level={level}
      expanded={expanded}
      toggleExpand={toggleExpand}
    />
    {expanded && (
      <Submenus
        key={1}
        level={level + 1}
        menuItems={menuItem.children}
        expandedIndex={expandedIndex}
        toggleExpandFn={toggleExpandFn}
        shouldShow={expanded}
      />
    )}
  </MenuRow>
);
